const { Client } = require("@notionhq/client")

// 1. Define your Base URL and global configurations in one place
const BASE_URL = "https://akulchhillar.pythonanywhere.com/"
    
const REQUEST_HEADERS = {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true" // 🚀 Automatically bypasses the Ngrok warning screen globally
};

// 2. Exported API Functions using the base URL variable
export function getHome() {
    return fetch(`${BASE_URL}/gethome`, {
        method: "GET",
        headers: REQUEST_HEADERS
    })
    .then((res) => res.json());
}

export function getBooks(category) {
    return fetch(`${BASE_URL}/getrecommendations?category=${category}`, {
        method: "GET",
        headers: REQUEST_HEADERS
    })
    .then((res) => res.json());
}

// 3. Initializing the Notion client
export const notion = new Client({
  auth: "secret_v4MTe3b7uAcRWBgHDD4ID607ZeNY9bJfuZiZTAENQvQ",
});